/**
 * Phase 5d/5f — Lesen pro Aggregat über Repositories / Read-Source (Composition Root).
 */

import {
  getSalesRepository,
  getPurchasesRepository
} from '../../app/di/container';

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export function listSalesForBusiness(businessId) {
  return getSalesRepository().listSales(businessId);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export function listPurchasesForBusiness(businessId) {
  return getPurchasesRepository().listPurchases(businessId);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function listLotsForBusiness(businessId) {
  const { readLotsFromBestSource } = await import('../../utils/lotsReadSource');
  return readLotsFromBestSource(businessId);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function listCustomersForBusiness(businessId) {
  const { readCustomersFromBestSource } = await import('../../utils/customersReadSource');
  return readCustomersFromBestSource(businessId);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function listProductsForBusiness(businessId) {
  const { readProductsFromBestSource } = await import('../../utils/productsReadSource');
  return readProductsFromBestSource(businessId);
}
